import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import { useInstance } from 'intact-vue-next';
import { inArray } from './useChecked';
import { toggleArray } from '../utils';
export function useTree(data) {
  var instance = useInstance();
  function isSpreaded(key) {
    return inArray(instance.get('spreadKeys'), key);
  }
  function toggleSpreadRow(_x, _x2) {
    return _toggleSpreadRow.apply(this, arguments);
  }
  function _toggleSpreadRow() {
    _toggleSpreadRow = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, rowData) {
      var _instance$get2, spreadKeys, load;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _instance$get2 = instance.get(), spreadKeys = _instance$get2.spreadKeys, load = _instance$get2.load;
            instance.set('spreadKeys', toggleArray(spreadKeys, key));
            if (!(load && data.value && !rowData.loaded)) {
              _context.next = 8;
              break;
            }
            rowData.loaded = false;
            _context.next = 6;
            return load(rowData);
          case 6:
            rowData.loaded = true;
            instance.forceUpdate();
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _toggleSpreadRow.apply(this, arguments);
  }
  function loopData(cb, shouldBreak) {
    if (shouldBreak === void 0) {
      shouldBreak = false;
    }
    var _instance$get = instance.get(),
      childrenKey = _instance$get.childrenKey;
    loopDataWithChildrenKey(data.value, childrenKey, cb, shouldBreak);
  }
  return {
    isSpreaded: isSpreaded,
    toggleSpreadRow: toggleSpreadRow,
    loopData: loopData
  };
}
export function loopDataWithChildrenKey(data, childrenKey, cb, shouldBreak) {
  if (!data) return;
  var index = -1;
  var loop = function loop(data, level, meta) {
    for (var i = 0; i < data.length; i++) {
      index++;
      var value = data[i];
      var ret = cb(value, index, level, meta);
      if (shouldBreak && ret) return true;
      if (childrenKey) {
        var children = value[childrenKey];
        if (Array.isArray(children)) {
          if (loop(children, level + 1, ret)) {
            return true;
          }
        }
      }
    }
    return false;
  };
  loop(data, 0, null);
}